import axios from 'axios';
import { API_RADAR_CONTRACTS, API_RADAR_TERRITORIES, API_RADAR_LAST_BASETIME, API_RADAR_VALIDTIMES, API_RADAR_GEOJSON, API_CREATE_RADAR_CONTRACT, API_EDIT_RADAR_CONTRACT, API_DELETE_RADAR_CONTRACT } from '../../constants'

export default {
  state: {
    radar: [],
    validtimes: [],
    geoJson: [],
    basetime: null,
    territories: [],
    parameters: ['precipitation_intensity'],
    contract: null,
    contracts: []
  },
  mutations: {
    SET_RADAR_TERRITORIES: (state, payload) => {
      state.territories = payload;
    },
    SET_VALIDTIMES: (state, payload) => {
      state.validtimes = payload;
    },
    SET_BASETIME: (state, payload) => {
      state.basetime = payload;
    },
    SET_RADAR_GEOJSON: (state, payload) => {
      state.geoJson = payload;
    },
    SET_RADAR: (state, payload) => {
      state.radar = payload;
    },
    SET_RADAR_CONTRACT: (state, payload) => {
      state.contract = payload;
    },
    SET_RADAR_CONTRACTS: (state, payload) => {
      state.contracts = payload;
    },
    DELETE_RADAR_CONTRACT(state, payload) {
      const index = state.contracts.findIndex(item => item.id === payload);

      if (index !== -1) {
        state.contracts.splice(index, 1);
      }
    },
  },
  actions: {
    FETCH_RADAR_TERRITORIES: async (context) => {
      const url = API_RADAR_TERRITORIES;
      let response = await axios.get(url);
      const data = response.data.result.data;
      context.commit('SET_RADAR_TERRITORIES', data);
      return data;
    },
    FETCH_RADAR_LAST_BASETIME: async (context, payload) => {
      const url = `${API_RADAR_LAST_BASETIME(payload.territory, payload.parameter)}`;
      let response = await axios.get(url);
      const data = response.data.result;
      context.commit('SET_BASETIME', data);
      return data;
    },
    FETCH_RADAR_VALIDTIMES: async (context, payload) => {
      const url = `${API_RADAR_VALIDTIMES(payload.territory, payload.parameter, payload.basetime)}`;
      let response = await axios.get(url);
      const data = response.data.result.data;
      context.commit('SET_VALIDTIMES', data);
      return data;
    },
    FETCH_RADAR_GEOJSON: async (context, payload) => {
      const url = `${API_RADAR_GEOJSON(payload.territory, payload.parameter, payload.validtimes)}`;
      let response = await axios.get(url);
      const data = response.data.result.data;
      context.commit('SET_RADAR_GEOJSON', data);
      return data;
    },
    FETCH_RADAR_CONTRACTS: async (context, payload) => {
      const take = 1000;
      const skip = 0;
      const url = `${API_RADAR_CONTRACTS(payload.userId, take, skip)}`;
      let response = await axios.get(url);
      const data = response.data.result.data;
      context.commit('SET_RADAR_CONTRACTS', data);
      return data;
    },
    CREATE_RADAR_CONTRACT: async (context, payload) => {
      try {
        let userResponse = await axios.post(API_CREATE_RADAR_CONTRACT, payload);
        context.commit('SET_RADAR_CONTRACT', userResponse.data.result);
        context.commit('PUSH_SUCCESS', 'Контракт успешно создан');
        return userResponse.data.result;
      } catch (err) {
        context.commit('PUSH_ERROR_MESSAGE', err);
      }
    },
    UPDATE_RADAR_CONTRACT: async (context, payload) => {
      try {
        await axios.put(API_EDIT_RADAR_CONTRACT, payload);
        context.commit('SET_RADAR_CONTRACT', payload);
        context.commit('PUSH_SUCCESS', 'Контракт успешно изменен');
      } catch (err) {
        context.commit('PUSH_ERROR', err);
      }
    },
    DELETE_RADAR_CONTRACT: async (context, payload) => {
      try {
        await axios.delete(API_DELETE_RADAR_CONTRACT(payload.user_id, payload.id));
        context.commit('DELETE_RADAR_CONTRACT', payload.id);
        context.commit('PUSH_SUCCESS', 'Контракт успешно удален');
        return true;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return false;
      }
    },
  },
  getters: {
    RADAR_TERRITORIES: state => {
      return state.territories;
    },
    RADAR_GEOJSON: state => {
      return state.geoJson;
    },
    RADAR_VALIDTIMES: state => {
      return state.validtimes;
    },
    BASETIME: state => {
      return state.basetime;
    },
    RADAR_PARAMETERS: state => {
      return state.parameters;
    },
    RADAR_CONTRACT_BY_ID(state) {
      return contractId => {
        return state.contracts.find(contract => contract.id === contractId)
      }
    },
    RADAR_CONTRACTS: state => {
      return state.contracts;
    },
  }
}